<prlw-last-deals-table-header-row-ui
  [showContent]="showContent"
  [columns]="columns$ | async"
  [gridSize]="gridSize$ | async"
></prlw-last-deals-table-header-row-ui>
